import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    CwCaseTypeStepObjectComponent
} from "../../component/protected-components/object-component/cw-case-type-step-object-component/cw-case-type-step-object.component";

@Injectable({
    providedIn: 'root'
})
export class CwCaseTypeStepService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/caseTypeSteps');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return CwCaseTypeStepObjectComponent;
        }
        return null;
    }

}
